const ErrorIndicator = ({error}) => {
  return <div className='error'>{`Произошла ошибка - ${error.message}`}</div>;
};

export default ErrorIndicator;